import cookies from 'js-cookie';

const state = {
  isAuthenticated: false
};

const getters = {
  isAuthenticated: ({ isAuthenticated }) => {
    return isAuthenticated;
  }
};

const actions = {
  async checkAuthenticated({ commit }) {
    const jwt = await cookies.get('_us_token');
    const currentUser = await cookies.getJSON('_us_user');
    const hasValidCredentials = !!(jwt && currentUser);

    if (hasValidCredentials) {
      commit("SAVE_CURRENT_USER", currentUser);
      commit("UPDATE_AUTHENTICATED", true);
    } else {
      commit("SAVE_CURRENT_USER", null);
      commit("UPDATE_AUTHENTICATED", false);
    }
  }
}

const mutations = {
  UPDATE_AUTHENTICATED(state, newValue) {
    state.isAuthenticated = newValue;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js